import { CURRENT_POLICY_VERSION } from '../../constants'
import store from '../../store/index'
import { getToken, logout } from '../../services/users'

export const validateToken = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && getToken() && !store.getters.isAuthenticated) {
    store.dispatch('authenticate')
      .then(() => next())
      .catch(() => {
        logout()
        store.dispatch('logout')
        next('/')
      })
  } else {
    next()
  }
}

export const maybeRedirectToProfile = (to, from, next) => {
  if (from.path !== '/') {
    next()
    return
  }

  // If the user is authenticated and is currently on the home page, then redirect them to their profile
  store.dispatch('authenticate')
    .then(() => {
      if (store.getters.acceptedPolicyVersion !== CURRENT_POLICY_VERSION) {
        next()
        return
      }

      store.commit('resetResources')
      next({
        path: store.getters.profileUrl,
        query: to.query
      })
    })
    .catch(() => next())
}

export const requiresAuth = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // This route requires auth, check if the user is logged in.
    // If not, then redirect to the login page.
    if (store.getters.isAuthenticated) {
      next()
    } else {
      store.dispatch('authenticate')
        .then(next)
        .catch(() => {
          const path = to.meta.hasAuthModal ? '/bejelentkezes-szukseges' : '/'

          next({
            path,
            query: { redirect: to.fullPath }
          })
        })
    }
  } else {
    next()
  }
}

export const requiresAdmin = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    // This route requires admin role, check if the user is logged in and is an admin.
    // If not, then redirect to the login page.
    if (store.getters.isAuthenticated && store.getters.isPrivileged) {
      next()
    } else {
      next(store.getters.profileUrl)
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/guards/auth.js